<template>
  <div class="site-header">
    
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  data () { return {} },
  components: {}
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.site-header {
  height: 10vh;
  width: 100%;
  background-color: $dark-green;
}

.footer-logo {
  height: 10vh;
}


</style>
